<template
>
	<div class="card mb-1 pt-2">
		<div class="card-body p-4 p-md-5">
			<h5 class="text-highlighted mb-3">Údaje o účte</h5>
			<form class="personal-info-form" @submit.prevent="sendRegistrationForm()">
				<form-group v-model="formModel" :fields="formSchema"/>
				<div class="text-center">
					<button type="submit" class="btn btn-outline-highlighted col-12 col-md-3">
						<font-awesome-icon
								v-if="loading"
								icon="spinner"
								class="ml-2"
								spin
						/>
						Pokračovať
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import FormGroup from "./form/FormGroup";
import {token} from "@/store/modules/onboarding";

export default {
	name: "RegistrationForm",
	components: {
		FormGroup
	},
	data() {
		return {
			loading: false,
			formModel: {
				username: "",
				email: "",
				phone: "",
				password: "",
				passwordRetry: "",
				SFA: "",
				clientZone: false
			},
			formSchema: [
				{
					label: "Rodné číslo (bez lomky) / IČO klienta",
					placeholder: "Zadajte rodné číslo alebo IČO klienta",
					model: "username",
					formWrapperClass: "col-md-6",
					required: true
				},
				{
					label: "E-mail",
					placeholder: "Zadajte e-mail",
					model: "email",
					formWrapperClass: "col-md-6",
					type: "email",
					required: true
				},
				{
					label: "Heslo",
					placeholder: "Zadajte heslo",
					model: "password",
					formWrapperClass: "col-md-6",
					type: "password",
					required: true
				},
				{
					label: "Potvrdenie hesla",
					placeholder: "Zopakujte heslo",
					model: "passwordRetry",
					formWrapperClass: "col-md-6",
					type: "password",
					required: true
				},
				{
					label: "Telefónne číslo",
					placeholder: "Zadajte svoje telefónne číslo",
					model: "phone",
					formWrapperClass: "col-md-6",
					mask: "+### ### ### ###",
					required: true
				},
				{
					label: "Kód SFA - REGFAP (nepovinné)",
					placeholder: "Vložte kód SFA (REGFAP)",
					model: "SFA",
					formWrapperClass: "col-md-6",
					required: false
				}
			]
		};
	},
	mounted() {
		this.$store.dispatch('onboarding/testServiceDown');
	},
	methods: {
		sendRegistrationForm() {
			if (this.formModel.password.length < 6) {
				this.$store.dispatch(
						"alert/warning",
						"Heslo musí obsahovať najmenej 6 znakov."
				);
			} else if (this.formModel.password !== this.formModel.passwordRetry) {
				this.$store.dispatch("alert/warning", "Zadané heslá sa nezhodujú.");
			} else {
				this.loading = true;
				this.$store
						.dispatch("onboarding/registration", this.formModel)
						.then(() => {
							this.$store
									.dispatch("onboarding/login", this.formModel)
									.then(() => {
										this.loading = false;
										this.$store.commit("onboarding/setRegistration", true);
										this.$parent.$parent.currentStep.next = true;
									})
									.catch(() => {
										this.loading = false;
									});
						})
						.catch(() => {
							this.loading = false;
						});
			}
		}
	}
};
</script>

<style lang="scss">
.personal-info-form {
	h3 {
		font-size: 14px;
		padding-top: 5px;
		padding-bottom: 10px;
	}

	hr {
		border-top-color: #9b9c9c;
		margin-top: 20px;
	}

	p {
		font-size: 12px;
		line-height: 170%;
	}
}
</style>
